"use strict";
exports.__esModule = true;
exports.useClasses = void 0;
var __1 = require("..");
exports.useClasses = __1.makeStyles(function (theme) {
    var _a, _b, _c, _d;
    return __1.createStyles({
        container: {
            display: 'flex',
            flexDirection: 'column',
            height: '100%'
        },
        header: {
            padding: 16,
            paddingBottom: 12
        },
        inputRoot: {
            '&:hover': {
                backgroundColor: (_a = theme.palette) === null || _a === void 0 ? void 0 : _a.background["default"]
            }
        },
        formControlRoot: {
            marginLeft: 'auto',
            marginBottom: 12
        },
        formControlLabel: {
            fontSize: 14
        },
        contentContainer: {
            flex: 1,
            display: 'flex',
            flexDirection: 'column',
            padding: 16,
            paddingTop: 0,
            paddingBottom: 48,
            overflowY: 'scroll'
        },
        item: {
            minHeight: 56,
            display: 'flex',
            boxShadow: '0px 1px 4px rgba(21, 43, 66, 0.16)',
            paddingLeft: 30,
            paddingRight: 16,
            border: "1px solid transparent",
            '&:not(:last-child)': {
                margin: '0 0 8px 0'
            }
        },
        dragItem: {
            border: "1px solid " + ((_b = theme.palette) === null || _b === void 0 ? void 0 : _b.primary[400]),
            boxShadow: (_c = theme.shadows) === null || _c === void 0 ? void 0 : _c[8]
        },
        switchTrack: {
            backgroundColor: (_d = theme.palette) === null || _d === void 0 ? void 0 : _d.grey[70]
        },
        informationContainer: {
            display: 'flex',
            alignItems: 'center',
            flex: 1
        },
        dragIcon: {
            marginRight: 16,
            fontSize: 18
        },
        dragIconDisabled: {
            opacity: 0.5,
            cursor: 'not-allowed'
        },
        text: {
            fontWeight: 600,
            flex: 1,
            marginRight: 16
        },
        showContainer: {
            display: 'flex',
            alignItems: 'center',
            cursor: 'pointer'
        },
        noClick: {
            pointerEvents: 'none'
        }
    });
});
//# sourceMappingURL=TableColumnSettingsStyles.js.map